// Single source of truth for the i18n URL/SEO scheme.
// App locale codes are UPPERCASE (EN/FI/SW) to match i18next init + localStorage (G4).
// Root URL (/) is FI — the primary market. SW/EN live under a path prefix.
// NOTE: SW (app code) maps to the ISO hreflang `sv` (Swedish), NOT "sw".

export const SITE_URL = 'https://abyfoods.fi';
export const DEFAULT_LOCALE = 'FI';

// Locales that have a routable, fully-translated surface.
export const LOCALES = ['FI', 'SW', 'EN'];

// app locale -> URL prefix ('' = served at root)
export const localeToPath = { FI: '', SW: 'sw', EN: 'en' };

// app locale -> hreflang / <html lang> value
export const localeToHreflang = { FI: 'fi', SW: 'sv', EN: 'en' };

// Derive the app locale from a pathname's first segment. Unknown -> default (FI).
export function localeFromPathname(pathname) {
  const seg = (pathname || '/').split('/').filter(Boolean)[0];
  if (seg === 'sw') return 'SW';
  if (seg === 'en') return 'EN';
  return 'FI';
}

// Build a localized path, preserving an optional sub-route (e.g. 'horeca').
//   localizedPath('FI')          -> '/'
//   localizedPath('SW')          -> '/sw'
//   localizedPath('EN','horeca') -> '/en/horeca'
//   localizedPath('FI','horeca') -> '/horeca'
export function localizedPath(locale, sub = '') {
  const parts = [localeToPath[locale], sub].filter(Boolean);
  return '/' + parts.join('/');
}

// Absolute URL for a locale + sub-route (used in canonical / hreflang / sitemap).
export function localizedUrl(locale, sub = '') {
  const path = localizedPath(locale, sub);
  return SITE_URL + (path === '/' ? '/' : path);
}
